<template>
    <div
        class="d-flex flex-column main-wrapper"
        style="
      padding-left: 6px !important;
      padding-right: 6px !important;
      height: 100vh;
      overflow-y: scroll;
      background: #202020;
      /* background-attachment: fixed; */
    "
    >
        <div class="container-fluid p-2 pt-3">
            <!-- style="scrollbar-width: none; -ms-overflow-style: none; background: #101010; height: 100vh; overflow-y: scroll; padding-bottom: 15rem; background-attachment: fixed;" -->
            <div>
                <div class="col-12 px-1 mb-5 pb-5">
                    <h2
                        class="text-white text-center mt-5"
                        v-if="!promotions.length"
                    >Coming Soon ...</h2>
                    <div
                        class="mt-2 mb-3"
                        style="box-shadow: none; background: rgb(21, 21, 21); border-radius: 2rem;"
                        v-for="(promotion, proIndex) in promotions"
                        :key="proIndex"
                    >
                        <a href="#">
                            <img
                                :src="promotion.image"
                                style="border-top-left-radius: 0.5rem; border-top-right-radius: 0.5rem; width: 100%;"
                                alt=""
                            >
                        </a>
                        <div class="px-3 py-2 d-flex justify-content-between">
                            <h3 class="text-white my-auto">
                                <img
                                    src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f4b8/512.gif"
                                    alt="💸"
                                    width="25"
                                    height="25"
                                >
                                {{ promotion.title }}
                            </h3>
                            <button
                                class="detail-button text-white col-3 my-2"
                                @click=" promotionIndex(proIndex)"
                            >{{ $t('detail') }}</button>
                        </div>

                        <van-overlay
                            :show="selectedPromotion === proIndex"
                            @click="selectedPromotion = null"
                        >
                            <div class="wrapper col-12 d-flex h-100vh">
                                <div
                                    class="col-12 mx-auto my-auto py-4 px-4"
                                    style="background: #202124 !important;;"
                                >
                                    <h2
                                        class="pb-3"
                                        style="color: #fff"
                                    > {{ promotion.title }}</h2>
                                    <span
                                        style="color: #fff"
                                        v-html="promotion.description"
                                    ></span>
                                    <div class="d-flex gap-3 mt-4">
                                        <a
                                            v-if="promotion.social_links?.telegram"
                                            :href="promotion.social_links.telegram"
                                            target="_blank"
                                            title="Telegram"
                                            class="mr-3"
                                        >
                                            <img
                                                src="../../../assets/telegram.png"
                                                alt="Telegram"
                                                width="30"
                                                height="30"
                                            />
                                        </a>

                                        <a
                                            v-if="promotion.social_links?.viber"
                                            :href="`viber://chat?number=${promotion.social_links.viber}`"
                                            title="Viber"
                                        >
                                            <img
                                                src="../../../assets/viber.png"
                                                alt="Viber"
                                                width="30"
                                                height="30"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </van-overlay>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            isPromotionsFetching: false,
            selectedPromotion: null,
            promotions: []
        };
    },
    methods: {
        ...mapActions(['fetchUser']),
        async fetchPromotions() {
            this.isPromotionsFetching = true;
            try {
                const res = await axios.get('/promotions', {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                });
                this.promotions = res.data.data;
            } catch (e) {
                console.error(e);
                // this.$toast.fail('Failed!');
            } finally {
                this.isPromotionsFetching = false;

            }
        },
        promotionIndex(index) {
            this.selectedPromotion = index;
        },
    },
    async mounted() {
        const authUser = await this.fetchUser();
        if (!authUser) {
            this.$router.push('/auth/login');
        }
        this.fetchPromotions();
    },
};
</script>
<style scoped>
.detail-button {
    appearance: none;
    /* background-color: transparent; */
    background: linear-gradient(to bottom, #ffc500 0%, #ff4500 50%, #c71600 100%) !important;
    color: white !important;
    border: none;
    text-transform: uppercase;
    border-radius: 14px;
    box-sizing: border-box;
    /* color: black !important; */
    cursor: pointer;
    display: inline-block;
    font-family: Roobert, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 0.9rem;
    font-weight: 450;
    line-height: normal;
    margin: 0;
    min-height: 15px;
    min-width: 0;
    outline: none;
    padding: 1px 5px;
    text-align: center;
    text-decoration: none;
    transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    width: 100%;
    will-change: transform;
}

.detail-button:disabled {
    pointer-events: none;
}

.detail-button:hover {
    background: linear-gradient(to bottom, #ffc500 0%, #ff4500 50%, #c71600 100%) !important;
    color: white !important;
    /* box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px; */
    transform: translateY(-2px);
    /* border: black !important; */
}

.detail-button:active {
    box-shadow: none;
    transform: translateY(0);
    /* border: black !important; */
    background: #2B2C2E;
}

.animate-charcter {
    text-transform: uppercase;
    background-image: linear-gradient(-225deg,
            #B50200 0%,
            #f3e706 29%,
            #B50200 67%,
            #f3e706 100%);
    background-size: auto auto;
    background-clip: border-box;
    background-size: 200% auto;
    color: #fff;
    background-clip: text;
    text-fill-color: transparent;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: textclip 2s linear infinite;
    display: inline-block;
    /* font-size: 190px; */
}

@keyframes textclip {
    to {
        background-position: 200% center;
    }
}
</style>